export var NBRequestStatus;
(function (NBRequestStatus) {
    NBRequestStatus["OK"] = "Ok";
    NBRequestStatus["InvalidParams"] = "400";
    NBRequestStatus["InvalidAPIKey"] = "401";
    NBRequestStatus["InsufficientPermission"] = "403";
    NBRequestStatus["RouteGenerateFailed"] = "422";
    NBRequestStatus["RequestLimited"] = "429";
})(NBRequestStatus || (NBRequestStatus = {}));
//# sourceMappingURL=common.js.map